import React, { useEffect, useState } from 'react';
import api from '../api';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import BackButton from '../components/BackButton';
import { useNavigate } from 'react-router-dom';

export default function CustomerPage() {
  const [customers, setCustomers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  // const [form, setForm] = useState({ Name: '', GSTIN: '', Address: '', Phone: '', Email: '' });
  const [form, setForm] = useState({ Name: '', GSTIN: '', Address: '', Phone: '', Email: '', OpeningBalance: 0 });

  const [editingId, setEditingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const [sortField, setSortField] = useState('Name');
  const [sortOrder, setSortOrder] = useState('asc');
const navigate = useNavigate();
  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = () => {
    api.get('/customers').then(res => {
      setCustomers(res.data);
      setFilteredCustomers(res.data);
    }).catch(err => console.error('Failed to fetch customers:', err));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const url = editingId ? `/customers/update/${editingId}` : '/customers/add';
    const method = editingId ? 'put' : 'post';

    api[method](url, form).then(() => {
      setForm({ Name: '', GSTIN: '', Address: '', Phone: '', Email: '' });
      setEditingId(null);
      fetchCustomers();
    }).catch(err => console.error('Failed to save customer:', err));
  };

  const handleEdit = (customer) => {
    setForm(customer);
    setEditingId(customer.CustomerID);
  };

  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this customer?')) {
      api.delete(`/customers/delete/${id}`).then(fetchCustomers)
        .catch(err => console.error('Failed to delete customer:', err));
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
    const filtered = customers.filter(c =>
      c.Name?.toLowerCase().includes(value) ||
      c.GSTIN?.toLowerCase().includes(value)
    );
    setFilteredCustomers(filtered);
    setCurrentPage(1);
  };

  const handleSort = (field) => {
    const order = (sortField === field && sortOrder === 'asc') ? 'desc' : 'asc';
    setSortField(field);
    setSortOrder(order);

    const sorted = [...filteredCustomers].sort((a, b) => {
      if (!a[field]) return 1;
      if (!b[field]) return -1;
      return order === 'asc'
        ? a[field].toLowerCase().localeCompare(b[field].toLowerCase())
        : b[field].toLowerCase().localeCompare(a[field].toLowerCase());
    });

    setFilteredCustomers(sorted);
  };

  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredCustomers);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Customers');
    XLSX.writeFile(wb, 'Customers.xlsx');
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    autoTable(doc, {
      head: [['Name', 'GSTIN', 'Phone', 'Email', 'Address']],
      body: filteredCustomers.map(c => [c.Name, c.GSTIN, c.Phone, c.Email, c.Address])
    });
    doc.save('Customers.pdf');
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredCustomers.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredCustomers.length / itemsPerPage);

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <div className="container mt-5" style={{ background: '#f4f6f9', padding: '20px', borderRadius: '10px' }}>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="text-center flex-grow-1 fw-bold text-primary">Customer Management</h2>
        <div className="d-flex align-items-center gap-2 ms-3">
          <BackButton />
          <div className="badge bg-primary text-white p-2" style={{ fontSize: '0.85rem' }}>
            Total: {customers.length}
          </div>
        </div>
      </div>

      <div className="mb-4 d-flex flex-wrap gap-2">
        <input
          type="text"
          className="form-control shadow-sm"
          placeholder="Search by Name or GSTIN"
          value={searchTerm}
          onChange={handleSearch}
          style={{ maxWidth: '250px' }}
        />
        <button className="btn btn-success shadow-sm" onClick={exportToExcel}>Export Excel</button>
        <button className="btn btn-danger shadow-sm" onClick={exportToPDF}>Export PDF</button>
      </div>

      <form onSubmit={handleSubmit} className="border rounded p-4 mb-4 bg-white shadow">
        <div className="row g-3">
          <div className="col-md-4">
            <input type="text" placeholder="Customer Name" className="form-control" value={form.Name} onChange={(e) => setForm({ ...form, Name: e.target.value })} required />
          </div>
          <div className="col-md-4">
            <input type="text" placeholder="GSTIN (Optional)" className="form-control" value={form.GSTIN} onChange={(e) => setForm({ ...form, GSTIN: e.target.value })} />
          </div>
          <div className="col-md-4">
            <input type="text" placeholder="Phone" className="form-control" value={form.Phone} onChange={(e) => setForm({ ...form, Phone: e.target.value })} />
          </div>
          <div className="col-md-4">
            <input type="email" placeholder="Email" className="form-control" value={form.Email} onChange={(e) => setForm({ ...form, Email: e.target.value })} />
          </div>
          <div className="col-md-4">
            <input type="text" placeholder="Address" className="form-control" value={form.Address} onChange={(e) => setForm({ ...form, Address: e.target.value })} />
          </div>
          <div className="col-md-4">
  <input
    type="number"
    placeholder="Opening Balance"
    className="form-control"
    value={form.OpeningBalance || ""}
    onChange={e => setForm({ ...form, OpeningBalance: e.target.value })}
    min="0"
    step="0.01"
  />
</div>

          <div className="col-md-4">
            <button type="submit" className="btn btn-primary w-100">
              {editingId ? 'Update Customer' : 'Add Customer'}
            </button>
          </div>
        </div>
      </form>

      <div className="table-responsive shadow rounded">
        <table className="table table-bordered table-hover">
          <thead className="table-primary">
            <tr>
              <th onClick={() => handleSort('Name')} role="button">Name {sortField === 'Name' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}</th>
              <th onClick={() => handleSort('GSTIN')} role="button">GSTIN {sortField === 'GSTIN' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}</th>
              <th>Phone</th>
              <th>Email</th>
              <th>Address</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map(customer => (
              <tr key={customer.CustomerID} className="hover-shadow">
                <td>{customer.Name}</td>
                <td>{customer.GSTIN || '-'}</td>
                <td>{customer.Phone || '-'}</td>
                <td>{customer.Email || '-'}</td>
                <td>{customer.Address || '-'}</td>
                <td>
                  <button className="btn btn-sm btn-outline-primary me-2" onClick={() => handleEdit(customer)}>
                    <i className="bi bi-pencil"></i>
                  </button>
                  <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(customer.CustomerID)}>
                    <i className="bi bi-trash"></i>
                  </button>
                  <button
  className="btn btn-sm btn-info"
  onClick={() => navigate(`/customers/${customer.CustomerID}/ledger`)}
>
  Ledger
</button>

                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <nav className="mt-4">
          <ul className="pagination justify-content-center">
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
              <button className="page-link" onClick={() => goToPage(currentPage - 1)}>Previous</button>
            </li>

            {[...Array(totalPages)].map((_, idx) => (
              <li key={idx} className={`page-item ${currentPage === idx + 1 ? 'active' : ''}`}>
                <button className="page-link" onClick={() => goToPage(idx + 1)}>{idx + 1}</button>
              </li>
            ))}

            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
              <button className="page-link" onClick={() => goToPage(currentPage + 1)}>Next</button>
            </li>
          </ul>
        </nav>
      )}
    </div>
  );
}
